<p-dialog class="acv-modal" [modal]="true" [visible]="visibility" [draggable]="false" [resizable]="false" [closable]="false" [style]="{ width: '500px', minHeight: '400px' }">
  <app-trip-assigned-details #assignedTripDetail></app-trip-assigned-details>
  <ng-template pTemplate="header">
    <div class="dialogHeader flex align-items-center justify-content-between wd-100 pl-2">
      <h4 class="font-poppin text-color-grey4">
        <span class="font-bold">{{title}}</span>
      </h4>
      <p-button icon="pi pi-times" (onClick)="hide()" styleClass="p-button-text p-button-rounded"></p-button>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <h6 class="mb-2 font-poppin">Leg Name</h6>
    <div class="trip-detail font-poppin border-round mt-3">
      <ul class="trip-detail-list">
        <li *ngFor="let item of data; let i = index" class="flex gap-3 mb-4">
          <span class="count" [ngClass]="{'active': item.active}">{{i + 1}}</span>
          <span (click)="onLegClicked(item)">{{item.name}}</span>
        </li>
      </ul>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end">
      <p-button pButton class="p-button-text elevated-btn primary font-poppin" (click)="hide()">Done</p-button>
    </div>
  </ng-template>
</p-dialog>
